import React, { Component } from 'react';
import style from './_userinfo.scss';

class UserInfo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      user: this.props.user
    }
  }

  componentWilLReceiveProps(nextProps) {
    if (nextProps.user != this.state.user) {
      this.setState({
        user: nextProps.user
      })
    }
  }

  render() {
    return (
      <div>
        <table className='userinfo-table'>
          <tbody className='userinfo-table-list'>
            <tr className='userinfo-item'>
              <td>Tên:</td>
              <td>{this.state.user.fullname}</td>
              <td>Email</td>
              <td>{this.state.user.email}</td>
            </tr>
            <tr className='userinfo-item'>
              <td>SĐT:</td>
              <td>{this.state.user.phone}</td>
              <td>Địa chỉ</td>
              <td>{this.state.user.address}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./components/partials/userinfo/UserInfo.jsx